import { render, staticRenderFns } from "./AddEPaper2.vue?vue&type=template&id=930f4b64&scoped=true&"
import script from "./AddEPaper2.vue?vue&type=script&lang=js&"
export * from "./AddEPaper2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "930f4b64",
  null
  
)

export default component.exports